import Accordion from '@/common/components/Accordion'
import AreaChart from '@/common/components/AreaChart';
import InfoField from '@/common/components/InfoField'
import Skeleton from '@/common/components/Skeleton';
import { ChartData } from '@/common/types/chart.type';
import { formatCurrency } from '@/common/utils/formatters';
import { EquipmentModelLatestFipeData } from '@/features/equipmentModels/types/equipmentModelLatestFipe'

interface FipeMainDataAccordionProps {
  fipeData?: EquipmentModelLatestFipeData
  fipePricesData?: ChartData
  userHasPermissionToListFipePrices?: boolean
  fipePricesDataError?: boolean
  fipePricesDataIsLoading?: boolean
}

export default function FipeMainDataAccordion({ 
  fipeData,
  fipePricesData,
  userHasPermissionToListFipePrices,
  fipePricesDataError,
  fipePricesDataIsLoading = false
}: FipeMainDataAccordionProps) {
  const referenceDate = fipeData?.latest_price_reference_month && fipeData?.latest_price_reference_year
    ? `(${fipeData.latest_price_reference_month}/${fipeData.latest_price_reference_year})`
    : '';

  const renderChartSection = () => {
    if (!userHasPermissionToListFipePrices || fipePricesDataError) return null

    if (fipePricesDataIsLoading) return (
      <Skeleton className='w-full min-h-[280px]' />
    )

    const currentPrice = fipePricesData?.data?.at(-1)?.value

    return (
      <div>
        <div className='bg-white-200 p-2 rounded-t-lg max-w-[calc(100%-110px)]'>
          <h2 className='text-xs'>Tabela Fipe</h2>
          <span className='text-lg font-bold text-white-800'>{formatCurrency(Number(currentPrice) || 0)}</span>
        </div>
        {fipePricesData?.data && <AreaChart chartData={fipePricesData} className="max-h-[220px]" />}
      </div>
    )
  }

  return (
    <Accordion
      name="FipeMainData"
      head="Dados Principais"
      defaultOpen
      body={
        <div className='flex flex-col gap-4'>
          <div className='flex items-center gap-1 w-full'>
            <InfoField 
              label="Código Fipe" 
              value={fipeData?.raw?.["Codigo Fipe"]} 
            />
            <InfoField 
              label="Descrição" 
              value={fipeData?.description} 
            />
            <InfoField 
              label={`Preço atual ${referenceDate}`} 
              value={formatCurrency(Number(fipeData?.latest_price))} 
            />
          </div>

          {renderChartSection()}
        </div>
      }
    />
  )
}